module.exports = global["Bloodhound"] = require("-!/usr/lib/node_modules/babel-loader/lib/index.js??ref--10!./typeahead.bundle.js");